import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function lazyNamed(
  factory: () => Promise<Record<string, React.ComponentType<any>>>,
  name: string,
): React.LazyExoticComponent<React.ComponentType<any>> {
  return React.lazy(() =>
    factory().then((module) => ({
      default: module[name],
    })),
  );
}

/** Wrapper tipizzato per placeholder system admin (evita `unknown` sui props). */
export const LazySystemAdminPlaceholder = React.lazy(async () => {
  const module = await import('../pages/SystemAdmin/SystemAdminPlaceholder');
  return { default: module.SystemAdminPlaceholder };
});

export const LazyAgentShell = React.lazy(() =>
  import('../pages/AgentShell').then((module) => ({ default: module.AgentShell })),
);

export const LazySelectCompany = lazyNamed(() => import('../pages/SelectCompany'), 'SelectCompany');
export const LazyForgotPassword = lazyNamed(() => import('../pages/ForgotPassword'), 'ForgotPassword');
export const LazyResetPassword = lazyNamed(() => import('../pages/ResetPassword'), 'ResetPassword');
export const LazyAcceptInvitation = lazyNamed(
  () => import('../pages/AcceptInvitation'),
  'AcceptInvitation',
);
export const LazySystemAdminLayout = lazyNamed(
  () => import('../layouts/SystemAdminLayout'),
  'SystemAdminLayout',
);
export const LazySystemAdminCompanies = lazyNamed(
  () => import('../pages/SystemAdmin/SystemAdminCompanies'),
  'SystemAdminCompanies',
);
export const LazySystemAdminCompanyForm = lazyNamed(
  () => import('../pages/SystemAdmin/SystemAdminCompanyForm'),
  'SystemAdminCompanyForm',
);
export const LazySystemAdminCompanyFormEditRoute = lazyNamed(
  () => import('../pages/SystemAdmin/SystemAdminRouteComponents'),
  'SystemAdminCompanyFormEditRoute',
);
export const LazySystemAdminCompanyUsersRoute = lazyNamed(
  () => import('../pages/SystemAdmin/SystemAdminRouteComponents'),
  'SystemAdminCompanyUsersRoute',
);
export const LazySystemAdminCompanyAgentsRoute = lazyNamed(
  () => import('../pages/SystemAdmin/SystemAdminRouteComponents'),
  'SystemAdminCompanyAgentsRoute',
);
export const LazyCompanyAdmin = lazyNamed(() => import('../pages/CompanyAdmin'), 'CompanyAdmin');
export const LazyManageUsers = lazyNamed(() => import('../pages/ManageUsers/ManageUsers'), 'ManageUsers');
export const LazyManageUser = lazyNamed(() => import('../pages/ManageUsers/ManageUser'), 'ManageUser');
export const LazyStats = lazyNamed(() => import('../pages/Stats/Stats'), 'Stats');
export const LazyB2bRootRedirect = lazyNamed(
  () => import('../components/B2bRootRedirect'),
  'B2bRootRedirect',
);
export const LazyNotFound = lazyNamed(() => import('../pages/NotFound'), 'NotFound');
